import gql from "graphql-tag";

import { Fragment, Theme } from "../types";

export const THEME_FRAGMENT = gql`
  fragment ThemeFragment on Theme {
    primary
    secondary
  }
`;

export type ThemeFragment = Fragment<Theme, Theme>;
